import React, {useEffect, useState} from 'react'
import {Box, useWindowSize, Link} from '@miro-site/core'
import styled, {useTheme, css} from 'styled-components'
import {IHeader} from '../api/interfaces'
import BottomLinks from './BottomLinks'

type SecondaryNavigationWrapper = {
  $isFixed?: boolean
  $offsetHeight: number
}

const SecondaryNavigationWrapper = styled(Box).attrs<SecondaryNavigationWrapper>(
  ({
    $offsetHeight,
    $isFixed = true,
    theme: {
      header: {secondaryNavigation},
    },
  }) => ({
    $styles: {
      opacity: $offsetHeight > 0 ? 1 : 0,
      transform: `translateY(${$offsetHeight}px)`,
      width: '100%',
      height: '200vh',
      left: 0,
      bottom: '100%',
      boxShadow: secondaryNavigation.boxShadow,
      background: secondaryNavigation.background,
      transition: secondaryNavigation.animation.container,
      position: $isFixed ? 'fixed' : 'absolute',
      willChange: 'transform',
      zIndex: 5,
    },
  }),
)<SecondaryNavigationWrapper>``

const BottomLinksContainer = styled(BottomLinks)<{$offsetHeight: number}>`
  ${({$offsetHeight}) =>
    $offsetHeight === 0 &&
    css`
      ${Link} {
        display: none;
      }
    `}
`

type SecondaryNavigationContainer = Pick<IHeader, 'bottomLinks'> & {
  isFixed?: boolean
  activeNavigation: number | null
  activeNavigationRef: React.RefObject<HTMLElement | null>
}

const SecondaryNavigationContainer = (props: SecondaryNavigationContainer): React.ReactElement => {
  const {activeNavigation, activeNavigationRef, bottomLinks, isFixed} = props

  const [offsetHeight, setOffsetHeight] = useState(0)

  const {height} = useWindowSize()

  const theme = useTheme()

  useEffect(() => {
    const newOffsetHeight = activeNavigationRef.current
      ? activeNavigationRef.current.offsetHeight +
        theme.header.height +
        (bottomLinks.length > 0 ? theme.header.bottomLinks.height : 0)
      : 0

    if (offsetHeight !== newOffsetHeight) {
      setOffsetHeight(newOffsetHeight)
    }
  }, [activeNavigation, height])

  return (
    <SecondaryNavigationWrapper $isFixed={isFixed} $offsetHeight={offsetHeight}>
      {bottomLinks.length > 0 && (
        <BottomLinksContainer bottomLinks={bottomLinks} $offsetHeight={offsetHeight} />
      )}
    </SecondaryNavigationWrapper>
  )
}

export default SecondaryNavigationContainer
